'use client';

import {styled, Typography} from '@mui/material';
import {MuiNextLink} from '@/components/MuiNextLink';

export const StyledFooterGroupHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.footerGroup.heading.fontSize,
  fontWeight: theme.typography.footerGroup.heading.fontWeight,
  textDecoration: 'none',
}));

export const StyledFooterExternalLink = styled(MuiNextLink)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.footerGroup.link.fontSize,
  fontWeight: theme.typography.footerGroup.link.fontWeight,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

type StyledFooterInternalLinkProps = {
  fontSize?: string | number;
};

export const StyledFooterInternalLink = styled(MuiNextLink, {
  shouldForwardProp: (prop) => prop !== 'fontSize',
})<StyledFooterInternalLinkProps>(({ theme, fontSize }) => {
  const fs = fontSize ?? theme.typography.footerGroup.link.fontSize;
  const fontSizeValue = typeof fs === 'number' ? `${fs}px` : fs;

  return {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    fontSize: fontSizeValue,
    fontWeight: theme.typography.footerGroup.link.fontWeight,
    '&:hover': {
      textDecoration: 'underline',
    },
  };
});

export const StyledFooterEmailLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  fontSize: theme.typography.footerGroup.link.fontSize,
  fontWeight: theme.typography.footerGroup.link.fontWeight,
  '&:hover': {
    textDecoration: 'underline',
  },
}));